import React from 'react'
import {translate} from 'react-i18next'
import Helmet from 'react-helmet'
import {LoadScript, GoogleMap, Marker} from '@react-google-maps/api'
import Header from '../components/Header.js'

const Company = translate('company')(
  ({t}) => (
    <div id="company">
      <Header current="company" />
      <div className="container">
        <div className="col1 col-pad1">
          <h1 className="page-title">Company</h1>
        </div>
        <div className="col3">
          <dl className="company-line">
            <dt className="company-label">{t('l1')}</dt>
            <dd className="company-value">{t('v1')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l2')}</dt>
            <dd className="company-value">{t('v2')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l3')}</dt>
            <dd className="company-value">{t('v3')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l4')}</dt>
            <dd className="company-value">{t('v4')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l5')}</dt>
            <dd className="company-value">{t('v5')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l6')}</dt>
            <dd className="company-value">{t('v6')}</dd>
          </dl>
          <dl className="company-line">
            <dt className="company-label">{t('l7')}</dt>
            <dd className="company-value">{t('v7')}</dd>
          </dl>
          <div className="company-split"></div>
          <LoadScript googleMapsApiKey="AIzaSyCvtzokukDRc10YKFmTR0Q50t67tl8yZAI">
            <GoogleMap
              zoom={15}
              center={{lat: 35.672856, lng: 139.690046}}
              options={{
                scrollwheel: false,
                styles: [
                  {
                    featureType: 'all',
                    stylers: [
                      {
                        saturation: -100
                      }
                    ]
                  }
                ]
              }}
              mapContainerStyle={{
                width: "800px",
                height: "400px"
              }}
            >
              <Marker position={{lat: 35.672856, lng: 139.690046}} />
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    </div>
  )
)

export default () => (
  <div>
    <Helmet
      meta={[
        {name: 'description', content: 'About Babels'},
        {property: 'og:title', content: 'About Babels'},
        {property: 'og:url', content: 'https://babels.co/about'},
        {property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff'},
        {property: 'og:image:width', content: '600'},
        {property: 'og:image:height', content: '400'},
        {property: 'og:description', content: 'About Babels'},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:site', content: '@null'},
        {name: 'twitter:creator', content: '@null'}
      ]}
    />
    <Company />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/company.js